import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'er-error-state',
  template: `
    <div class="er-error-state">
      <div class="er-error-state__icon"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
      <div class="er-error-state__title">{{ title }}</div>
      <div class="er-error-state__msg" *ngIf="message">{{ message }}</div>
      <div class="er-error-state__action" *ngIf="retryable">
        <button type="button" class="er-btn er-btn--secondary er-btn--sm" (click)="retry.emit()">Try again</button>
      </div>
    </div>`
})
export class ErErrorStateComponent {
  @Input() title = 'Something went wrong';
  @Input() message: string | null | undefined;
  @Input() retryable = true;
  @Output() retry = new EventEmitter<void>();
}
